export class NetworkError extends Error {
  cause: Error;

  constructor(cause: Error) {
    super(cause.message);

    this.cause = cause;
  }
}
